import React, { useEffect, useState } from "react";
import { Alert, Layout as AntdLayout, Dropdown, theme } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoggedIn, selectUserId, selectUserName, selectUser } from "../../pages/utillity-pages/login/store/auth.selectors";
import Menu from "../components/menu/menu";
import logo from '../../images/logo.png';
import minLogo from '../../images/login-logo-min.png';
import './layout.scss';
import { selectClosedAnnouncementIds, selectIsLightTheme, selectIsMenuCollapsed, selectLang } from "../global-store/global.selectors";
import type { MenuProps } from 'antd';
import store from '../../app/store';
import { useTranslation } from "react-i18next";
import { setActiveMenuGroupKey, setActiveMenuItemKey, setClosedAnnouncementIds, setIsLightTheme, setIsMenuCollapsed, setLang, setNoActionReportCount } from "../global-store/global.slice";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { HttpTransportType, HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { useMutation } from "react-query";
import { getAlarmReportsCount } from "../../pages/alarms/alarm-report/services/alarm-reports.service";
import { openNotification, useSaveUserSettingsMutation } from "../utils/utils";
import Userowl from "@userowl/js";
import { setChangePassword, setToken } from "../../../src/pages/utillity-pages/login/store/auth.slice";
import { useNavigate } from "react-router-dom";
import UserPanel from "../components/user-panel/UserPanel";
import i18next from "i18next";
import getUnicodeFlagIcon from "country-flag-icons/unicode"
import { getAppConfigs } from "../../../src/pages/admin-pages/app-config/services/appConfig.service";
import { fetchActiveAppStatus } from "../../../src/pages/app-status/services/app-status.service";
import { AppStatus } from "@/src/pages/app-status/models/app-status.model";
dayjs.extend(utc)
dayjs.extend(localizedFormat)
const { Content, Sider } = AntdLayout;
const FIVE_MINUTES = 5 * 60 * 1000;
interface LayoutProps {
    children: React.ReactNode;
}

const Layout = (props: LayoutProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const saveSettingsMutation = useSaveUserSettingsMutation(t);
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const isLightTheme = useSelector(selectIsLightTheme);
    const isMenuCollapsed = useSelector(selectIsMenuCollapsed);
    const userName = useSelector(selectUserName);
    const userId = useSelector(selectUserId);
    const user = useSelector(selectUser);
    const lang = useSelector(selectLang);
    const closedAnnouncementIds = useSelector(selectClosedAnnouncementIds);
    const [menuLogo, setMenuLogo] = useState<string | null>(null);
    const [activeAppStatus, setActiveAppStatus] = useState<AppStatus | null>(null);
    const [collapsedMenuLogo, setCollapsedMenuLogo] = useState<string | null>(null);
    const { token } = theme.useToken();
    const navigate = useNavigate();
    const [hubConnection, setHubConnection] = useState<HubConnection>();
    const items: MenuProps['items'] = [
        {
          label: t("auth.clear_cache_and_logout"),
          key: '1',
          onClick: () => {
            store.dispatch({
                type: "USER_LOGOUT"
            })
          }
        }
    ];

    useEffect(() => {
        getAppConfigMutation.mutateAsync();
        getAppStatusMutation.mutateAsync();
        const interval = setInterval(() => {getAppStatusMutation.mutateAsync();}, FIVE_MINUTES);

        return () => clearInterval(interval);
    }, []);

    const [languages, setLanguages] = useState<MenuProps['items']>([
        {
            key: 'tr',
            label: (<div onClick={() => languangeChange('tr')}>{getUnicodeFlagIcon('TR')} {t('languages.tr')}</div>),
        },
        {
            key: 'en',
            label: (<div onClick={() => languangeChange('en')}>{getUnicodeFlagIcon('GB')} {t('languages.en')}</div>),
        },
        {
            key: 'de',
            label: (<div onClick={() => languangeChange('de')}>{getUnicodeFlagIcon('DE')} {t('languages.de')}</div>),
        },
        {
            key: 'es',
            label: (<div onClick={() => languangeChange('es')}>{getUnicodeFlagIcon('ES')} {t('languages.es')}</div>),
        },
        {
            key: 'pt',
            label: (<div onClick={() => languangeChange('pt')}>{getUnicodeFlagIcon('PT')} {t('languages.pt')}</div>),
        },
        {
            key: 'pt-BR',
            label: (<div onClick={() => languangeChange('pt-BR')}>{getUnicodeFlagIcon('BR')} {t('languages.br')}</div>),
        },
        {
            key: 'fr',
            label: (<div onClick={() => languangeChange('fr')}>{getUnicodeFlagIcon('FR')} {t('languages.fr')}</div>),
        },
        {
            key: 'it',
            label: (<div onClick={() => languangeChange('it')}>{getUnicodeFlagIcon('IT')} {t('languages.it')}</div>),
        },
        {
            key: 'nl',
            label: (<div onClick={() => languangeChange('nl')}>{getUnicodeFlagIcon('NL')} {t('languages.nl')}</div>),
        }
    ]);

    const languangeChange = (key: string) => {
        saveSettingsMutation.mutateAsync({req: {
            lang: key
        }});
        dayjs.locale(key);
        dispatch(setLang(key));
        i18next.changeLanguage(key);
    };
    
    useEffect(() => {
        createHubConnection();
        dayjs.locale(lang);
        dispatch(setLang(lang));
        i18next.changeLanguage(lang);
    }, [])

    const createHubConnection = async () => {
        const hubCn = new HubConnectionBuilder().withUrl(`${process.env.REACT_APP_API_ENDPOINT}socket/no-action-report-data`, {
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets,
            accessTokenFactory: () => store.getState().authState.token ?? ''
        }).withAutomaticReconnect().build()
        
        try {
            await hubCn.start();
            setHubConnection(hubCn)
        } catch (e) {
            console.log("e", e)
        }
    }

    useEffect(()=>{
        if(hubConnection){
            hubConnection.on("Ping",()=>{
                getAlarmReportsCountMutation.mutate({ userId: userId});
            })
        }
    },[hubConnection])

    const getAlarmReportsCountMutation = useMutation(({ userId }: { userId: string }) => getAlarmReportsCount(userId), {
        onSuccess: (data) => {
            dispatch(setNoActionReportCount(data));
        },
        onError: () => {
            openNotification('error', t('common.error'), t('common.error_info'));
        }
    })

    useEffect(() => {
        Userowl.initialize(
          `654ab76bec2f822b24103ee8`          
        );
        Userowl.identify({
          name: userName,
          email: user.email,
          id: userId,
        });
      }, []);

    const greeting = () => {
        const currentTime = dayjs();
        
        let greeting;
        const hour = currentTime.hour();
        
        if (hour >= 5 && hour < 12) {
            greeting = `${t("greetings.morning")}`;
        } else if (hour >= 12 && hour < 18) {
            greeting = `${t("greetings.afternoon")}`;
        } else if (hour >= 18 && hour < 21) {
            greeting = `${t("greetings.evening")}`;
        } else {
            greeting = `${t("greetings.night")}`;
        }
        
        return <div>{greeting}</div>;
    };

    const onCollapse = () => {
        dispatch(setIsMenuCollapsed(isMenuCollapsed));
        saveSettingsMutation.mutate({
            req: {
                isMenuCollapsed: !isMenuCollapsed
            }
        })
    };

    const contentStyle = {
        backgroundColor: token.colorBgElevated,
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
        colorBgContainer: token.colorBgContainer,
        colorPrimary: token.colorPrimary,
        colorWarning: token.colorWarning,
        colorError: token.colorError,
        colorYellow: token['yellow-5'],
        colorBlue: token['blue-10']
    };

    const menuActions = (key: string) => {
        switch (key) {
            case '3':
                dispatch(setToken(null))
                break;
            case '2':
                dispatch(setChangePassword(user.email))
                break;
            case '1':
                dispatch(setActiveMenuGroupKey(null))
                dispatch(setActiveMenuItemKey(-1))
                navigate('userSettings')
                break;
            case 'clear_cache_and_logout':
                store.dispatch({
                    type: "USER_LOGOUT"
                })
                break;
            case '4':
                saveSettingsMutation.mutate({ req: {
                    isLightTheme: !isLightTheme
                }})
                dispatch(setIsLightTheme(!isLightTheme))
                break;
            default:
                break;
        }
    };

    const getAppConfigMutation = useMutation(() => getAppConfigs(), {
        onSuccess: (data) => {
            if (data.filter(x => x.key === "MenuLogo").length > 0)
            {
                setMenuLogo(`${data.filter(x => x.key === "MenuLogo")[0].value}`);
            }
  
            if (data.filter(x => x.key === "MenuCollapsedLogo").length > 0)
            {
                setCollapsedMenuLogo(`${data.filter(x => x.key === "MenuCollapsedLogo")[0].value}`);
            }
        },
        onError: () => {
            setMenuLogo(null);
            setCollapsedMenuLogo(null);
            openNotification('error', t('common.error'), t('common.error_info'));
        }
    });  

    const getAppStatusMutation = useMutation(() => fetchActiveAppStatus(), {
        onSuccess: (data) => {
            if (!!data) {
                setActiveAppStatus(data);
            }
        },
        onError: () => {
            setActiveAppStatus(null);
        }
    }); 

    return (
        <div>
            {isLoggedIn ?
                <AntdLayout hasSider={true}>
                    <Sider width={260} breakpoint="lg" collapsible onCollapse={() => onCollapse()} collapsed={isMenuCollapsed} theme={isLightTheme ? "light" : "dark"}>
                        <Dropdown menu={{ items }} trigger={['contextMenu']}>
                            {
                                !isMenuCollapsed ? (
                                    <div className="m-4 flex justify-center items-center">
                                        <img src={menuLogo ?? logo} height={40} alt="logo" />
                                    </div>
                                ) : (
                                    <div className="m-4 flex justify-center items-center">
                                        <img src={collapsedMenuLogo ?? minLogo} height={40} alt="logo" />
                                    </div>
                                )
                            }
                        </Dropdown>
                        <div style={{height: "calc(100% - 260px)", overflow: "auto"}}>
                            <Menu />
                        </div>
                        <div style={{height: 260, padding: "24px 0 48px", position: "absolute", bottom: 0, left: 0, right: 0, pointerEvents: 'none'}}>
                            <UserPanel
                                isMenuCollapsed={isMenuCollapsed}
                                userName={userName}
                                userEmail={user.email}
                                isLightTheme={isLightTheme}
                                lang={lang}
                                languages={languages}
                                contentStyle={contentStyle}
                                onAction={menuActions}
                                onLanguageChange={languangeChange}
                                greeting={greeting}
                            />
                        </div>
                    </Sider>
                    <AntdLayout>
                        <Content className="metis-content">
                            {
                                activeAppStatus && closedAnnouncementIds && closedAnnouncementIds?.filter(id => id === activeAppStatus.id).length === 0 && (
                                    <div className="mb-4">
                                        <Alert message={activeAppStatus.title} description={activeAppStatus.description} type="warning" showIcon closable onClose={() => dispatch(setClosedAnnouncementIds(activeAppStatus.id))} />
                                    </div>
                                )
                            }
                            {props.children}
                        </Content>
                    </AntdLayout>
                </AntdLayout>
                :
                <div>
                    {props.children}
                </div>
            }
        </div>
    )
}

export default Layout;